import React from "react";

export const DeconsolidationDetailContext = React.createContext(null);

export const useDeconsolidationDetailContext = () => {
    const context = React.useContext(DeconsolidationDetailContext);

    if (!context) throw new Error("Deconsolidation Detail Context not provided!");

    return context;
};
